//
//GET LOCAL PRICE FORM
//
import React, { Fragment, useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types'
import parse from 'html-react-parser';
import axios from 'axios';

import pidController from '../../../controllers/pidController';
import generalController from '../../../controllers/generalController'
import { fetchModelData } from '../../../controllers/ActionController'
import { getEndpointUrl } from '../../../utils/endPoints';
import { pushToGTMDataLayer, closeModal, convertLangCodeToSingleLetter, handleAnalyticsTrackingCodes, capitalizeWords } from '../../../utils/helpers';
import { languageController } from '../../../controllers/language/languageController';
import { useForm } from '../../../hooks/useForm';
import formLang from '../../../controllers/language/shared/form';

import Input from '../../1_Atoms/Forms/Input/Input';
import Checkbox from '../../1_Atoms/Forms/Checkbox/Checkbox';
import Select from '../../1_Atoms/Forms/Select/Select';
import Textarea from '../../1_Atoms/Forms/Textarea/Textarea';
import Button from '../../1_Atoms/Button/Button';
import FormGroup from '../../2_Molecules/FormGroup/FormGroup';
import Form from '../../2_Molecules/Form/Form';
import FormContainer from '../../2_Molecules/FormContainer/FormContainer';
import FormConfirmation from '../../2_Molecules/FormConfirmation/FormConfirmation';
import Modal from '../../2_Molecules/Modal/Modal';

function SendBuildToDealer({ formExtraParams }) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formError, setFormError] = useState(null);
  const [isModal, setIsModal] = useState(null);
  const [initVehicleData, setInitVehicleData] = useState(null);
  const modalRef = useRef(null);

  const { language, formDisclaimer, source, modal } = formExtraParams;

  const [dealerID, setDealerID] = useState(null);
  const [dealerName, setDealerName] = useState(null);

  const urlparams = generalController.getURLSearchParams();


  useEffect(() => {
    if (window.bnp_retailer_mode) {
      // Set the polling until we have a dealer vars with the information set as we should always have the dealer vars information
      const intervalRef = setInterval(()=>{
        const dealerVars = window.summaryCalculator.getDealerVars();
      
        if (dealerVars) {
          setDealerID(dealerVars.dealerId);
          setDealerName(capitalizeWords(dealerVars.dealerName));
  
          clearInterval(intervalRef);
        }
      }, 200);
    }
    if(modal !== null){
      setIsModal(modal === 'true')
    }
  }, []);

  useEffect(async ()=>{
    if(!isModal){
        const modelParam = decodeURI(urlparams.model).trim();
        const modelParamData = modelParam.split('|');

        if (modelParamData[0] && modelParamData[1]) {
          setInitVehicleData(await fetchModelData(modelParamData[0], modelParamData[1]));
        }
    }
  },[isModal])

  const initState = {
    firstname: '',
    lastname: '',
    email: '',
    postalcode: '',
    optin: false,
    phone:'',
    preferredContact:'',
    message:''
  }

  const [phoneValue, setPhoneValue] = useState('')
  const [validations, setValidations] = useState({
    firstname: ['required', 'name', 'nameMaxMin'],
    lastname: ['required', 'name', 'nameMaxMin'],
    email: ['required', 'email'],
    phone:['phone'],
    postalcode: ['required', 'postalcode'],
  })

  const transformIntoValidValue = (value) => {
    if (typeof value !== "string") {
      value = String(value); // Convert to string if it's not
    }
    
    let transformedValue = value;
    // Convert it into a proper number format
    transformedValue = transformedValue.replace(/\s/g, '').replace(',', '').replace('$', '');

    return transformedValue;
  }

  const transformIntoValidRoundedValue = (value) => {
    if (typeof value !== "string") {
      value = String(value); // Convert to string if it's not
    }

    // Remove non-numeric separators (spaces or commas)
    let normalized = value.replace(/\s/g, '').replace(',', '.');

    // Parse as float and round to nearest integer
    return Math.round(parseFloat(normalized));
  }

  const { handleSubmit, handleChange, data, errors, setData } = useForm({
    initState,
    validations,
    // Send the form data if validated
    onSubmit: async () => {
      try {

        function getMessageContent(currentLang){
          const hashLength = window.location.hash.split('/').length;
          let messageContent='';
          let currentStep = 'Trim';
          
          let annualKm = '16,000';

          if(hashLength < 7){
            currentStep = 'Options';
          }else{
            currentStep = window.location.hash.split('/')[6].split('?')[0];
          }

          if(summaryCalculator.AnnualMileage === 0){
            annualKm='24,000';
          }else if(summaryCalculator.AnnualMileage === 2){
            annualKm='20,000';
          }

          if(currentLang === 'en'){
            messageContent = `
              B&P Step: ${currentStep}
              Purchase Method Button: ${summaryCalculator.CurrentPurchaseMethod ? summaryCalculator.CurrentPurchaseMethod : ''}
              Wheels: ${summaryCalculator.SelectedWheel ? `|${summaryCalculator.SelectedWheel.image.overlay_image_suffix}|` : ''}
              Accessories: ${summaryCalculator.SelectedAccessories?.map((item)=>{return `|${item.part_number}|`}).join()}
              Mazda Owner Loyalty Program: ${summaryCalculator.LoyaltyChecked}
              Mazda Graduate Program Award: ${summaryCalculator.GraduateChecked}
              Mazda Military Program: ${summaryCalculator.MilitaryChecked}
              Annual KM: ${annualKm}
              Option Code: ${summaryCalculator?.selectedVehicle?.packageCode ? summaryCalculator.selectedVehicle.packageCode : ''}
              Option Name: ${summaryCalculator?.SelectedPackage && summaryCalculator?.SelectedPackage.option_code !== undefined ? `|${summaryCalculator.SelectedPackage.option_code}|` : 'Default'}
              Lease Weekly: ${summaryCalculator?.FinancialInfo?.calculatedLease?.leaseValues ? transformIntoValidRoundedValue(summaryCalculator.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex][summaryCalculator.IncludeTaxes ? 'weeklyWithTaxes' : 'weekly']) : ''}
            `
            if(summaryCalculator.IncludeRebates){
              messageContent += `Include Government Rebates: ${summaryCalculator.Incentives.incentive.value}
              `
            }
            messageContent += `
              Include fees and levies: ${summaryCalculator.IncludeFees}
              Include taxes: ${summaryCalculator.IncludeTaxes}
              Comments: ${data.message}
            `
          }else{
            annualKm = annualKm.replace(',', ' ');

            let frenchSteps = {"Trim": "Version",
            "Options": "Options",
            "colour": "Couleur",
            "wheels": "Roues",
            "accessories": "Accessoires", 
            "payments": "Prix et paiements",
            "summary": "Récapitulatif"}

            messageContent = `
              B&P Étape: ${frenchSteps[currentStep]}
              Méthode d’achat Bouton: ${summaryCalculator.CurrentPurchaseMethod ? 
                summaryCalculator.CurrentPurchaseMethod === 'Lease' ?
                  'Location' : 
                  'Financement' 
                : ''}
              Roues: ${summaryCalculator.SelectedWheel ? `|${summaryCalculator.SelectedWheel.image.overlay_image_suffix}|` : ''}
              Accessoires: ${summaryCalculator.SelectedAccessories?.map((item)=>{return `|${item.part_number}|`}).join(',')}
              Programme renouvellement de fidélité Mazda: ${summaryCalculator.LoyaltyChecked}
              Programme de diplômés Mazda: ${summaryCalculator.GraduateChecked}
              Programme Mazda pour militaires: ${summaryCalculator.MilitaryChecked}
              Kilométrage Annuel: ${annualKm}
              Code d’option: ${summaryCalculator?.selectedVehicle?.packageCode ? summaryCalculator.selectedVehicle.packageCode : ''}
              Nom de l’option: ${summaryCalculator?.SelectedPackage && `|${summaryCalculator?.SelectedPackage.option_code}|` !== undefined ? summaryCalculator.SelectedPackage.option_code : 'défaut'}
              Location hebdomadaire: ${summaryCalculator?.FinancialInfo?.calculatedLease?.leaseValues ? transformIntoValidRoundedValue(summaryCalculator.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex][summaryCalculator.IncludeTaxes ? 'weeklyWithTaxes' : 'weekly']) : ''}
            `
            if(summaryCalculator.IncludeRebates){
              messageContent += `Inclure les rabais gouvernementaux: ${summaryCalculator.Incentives.incentive.value}
              `
            }
            messageContent += `
              Inclure les frais et les prélèvements: ${summaryCalculator.IncludeFees}
              Inclure les taxes: ${summaryCalculator.IncludeTaxes}
              Commentaires: ${data.message}
            `
          }
          return messageContent;
        }

        const reqData = {
          firstname: data.firstname,
          lastname: data.lastname,
          email: data.email,
          postalcode: data.postalcode,
          phone: data.phone,
          preferredContact: data.preferredContact,
          source: source,
          language: convertLangCodeToSingleLetter(language),
          optin: data.optin ? 'on' : 'off',
        }

        if(typeof(summaryCalculator) === 'object'){
          const wheelPrice = summaryCalculator?.SelectedWheel ? summaryCalculator.SelectedWheel.price : 0;

          reqData.Incentive = summaryCalculator?.FinancialInfo?.calculatedCash?.specialIncentives ? summaryCalculator.FinancialInfo.calculatedCash.specialIncentives : 0,
          reqData.OptionTotal = wheelPrice //financialObj.calculatedFinance.options.total  // Wheels
          + summaryCalculator.SelectedNonModelPackage.financial.msrp
          + summaryCalculator.SelectedWarrantyPackage.financial.msrp // Warranty 
          + summaryCalculator.SelectedConnectedVehiclePackage.financial.msrp // Connected Vehicle 
          + summaryCalculator.SelectedAddedProtectionPackage.financial.msrp // Added Protection
          + summaryCalculator.SelectedAppearanceProtectionPlansPackage.financial.msrp // Appearance Protection
          + summaryCalculator.FinancialInfo.calculatedFinance.accessories.total // Accesories  
          + summaryCalculator.SelectedColourInterior.price
          + summaryCalculator.SelectedColourExterior.price,
          reqData.Message = getMessageContent('en'),
          reqData.Message_fr = getMessageContent('fr')
        
          if(summaryCalculator?.FinancialInfo?.calculatedCash?.specialIncentives){
            reqData.Incentive = summaryCalculator.FinancialInfo.calculatedCash.specialIncentives;
          }
        }else{
          reqData.Message = data.message;
        }

        // Vehicle
        if (urlparams.model) {
          reqData.year = initVehicleData.year;
          reqData.model = initVehicleData.model;
        } else{
            const selectedVehicle = sessionStorage.getItem("EngineAndDrivetrain");

            if (selectedVehicle) {
              const selectedVehicleParsed = JSON.parse(selectedVehicle);
              reqData.year = selectedVehicleParsed.model_year.year.id;
              reqData.model = selectedVehicleParsed.model_year.carline.id;
            }

        }

        function createJsonOutput(){
            const vehicleDataJSON = new Object(
              {
                year:'',
                carline:'',
                trim:'',
                modelCode:'',
                json: {
                  options:{
                    transmission:{
                      en:''
                    },
                    drivetrain:{
                      en:''
                    }
                  },
                  msrp:'',
                  allinpricing:{
                    freightpde:{
                      price:''
                    }
                  },
                },
                colour:{
                  name:{
                    en:''
                  }, 
                  interiorColours:[
                    {
                      name:{
                        en:''
                      }}
                  ]
                },
                downpayment:'',
                cash:{
                  subtotal:''
                },
                creditTotal:'',
                apr:{
                  selected:{
                    months:'',
                    rate:'',
                    approxMonthly:'',
                    approxBiweekly:'',
                    approxWeekly:''
                  },
                  balance:''
                },
                lease:{
                  selected:{
                    rate:'',
                    approxMonthly:'',
                    approxBiweekly:'',
                    approxWeekly:'',
                    balance:'',
                    payable:''
                  }
                }
              }
            )

            // let currentAprRate = summaryCalculator?.FinancialInfo?.calculatedFinance?.financeValues ? (summaryCalculator.FinancialInfo.calculatedFinance.financeValues.filter(res=>res.term === summaryCalculator.FinanceTerm).map(ele=>ele.rate)[0] * 100).toFixed(2) : 0;

            // if(summaryCalculator.LoyaltyChecked){
            //   currentAprRate = summaryCalculator?.FinancialInfo?.calculatedFinance?.financeValues ? (summaryCalculator.FinancialInfo.calculatedFinance.financeValues.filter(res=>res.term === summaryCalculator.FinanceTerm).map(ele=>ele.aprRateDiscounted)[0]) : 0;
            // }

            vehicleDataJSON.json.bodystyle = '';
            //vehicleDataJSON.Purchase = '';

            vehicleDataJSON.year = reqData.year;
            vehicleDataJSON.carline = reqData.model;

            vehicleDataJSON.trim = summaryCalculator?.SelectedTrim.trim_type.id ? summaryCalculator.SelectedTrim.trim_type.id : ''; //Add selected Trim
            vehicleDataJSON.json.options.transmission.en = summaryCalculator?.SelectedModel.drivetrain.id ? summaryCalculator.SelectedModel.transmission.id : ''; //Selected Transmission under Options 
            vehicleDataJSON.modelcode = summaryCalculator?.SelectedModel?.model_code ? summaryCalculator.SelectedModel.model_code : '';	//Model code (same one used on the URL and passed to TCCI)
            vehicleDataJSON.colour.name.en = summaryCalculator.SelectedColourExterior.id;	//Exterior colour id.
            vehicleDataJSON.colour.interiorColours[0].name.en = summaryCalculator.SelectedColourInterior.id;	//Interior Colour id

            vehicleDataJSON.json.msrp = summaryCalculator?.SelectedTrim?.financial?.msrp ? summaryCalculator.SelectedTrim.financial.msrp : 0;	//MSRP

            vehicleDataJSON.tradein = transformIntoValidValue(summaryCalculator?.TradeInField ? summaryCalculator.TradeInField : 0);	//Trade-in value entered
            vehicleDataJSON.downpayment = transformIntoValidValue(summaryCalculator?.DownPaymentValue ? summaryCalculator.DownPaymentValue : 0);	//DownPayment value entered by the user
            
            vehicleDataJSON.creditTotal = summaryCalculator?.FinancialInfo?.calculatedCash?.specialIncentives ? transformIntoValidRoundedValue(summaryCalculator.FinancialInfo.calculatedCash.specialIncentives) : 0;	//<Current Incentives value - same one shown at the top of the price and payment step>

            // Fetch the current subtotal
            let subtotal =  summaryCalculator?.CurrentCalculatedCash;
            // Convert it into a proper number format
            subtotal = subtotal.replace(/\s/g, '').replace(',', '.'); // Remove spaces and replace ',' with '.'
            // Convert into an integer expected from the API
            let integerSubtotal = Math.floor(Number(subtotal));

            vehicleDataJSON.cash.subtotal = integerSubtotal,	//Cash Total Price

            vehicleDataJSON.OptionName = summaryCalculator?.SelectedPackage && summaryCalculator?.SelectedPackage.option_id !== undefined ? summaryCalculator.SelectedPackage.option_id : 'Default';	//Package / Full name in either EN or FR.
            vehicleDataJSON.OptionCode = summaryCalculator?.selectedVehicle?.packageCode ? summaryCalculator.selectedVehicle.packageCode : '';	//GR00 / 4 character alphanumeric

            vehicleDataJSON.apr.selected.months = summaryCalculator?.FinanceTerm ? summaryCalculator.FinanceTerm : '';	//Finance Term selected
            
            let loanRate = summaryCalculator?.FinancialInfo?.calculatedFinance?.financeValues ? summaryCalculator?.FinancialInfo.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex].aprRate : '';
            if(summaryCalculator.LoyaltyChecked){
              loanRate = summaryCalculator?.FinancialInfo?.calculatedFinance?.financeValues ? summaryCalculator?.FinancialInfo.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex].aprRateDiscounted : '';
            }
            vehicleDataJSON.apr.selected.rate = loanRate;	//Finance Rate
            vehicleDataJSON.apr.selected.approxMonthly = summaryCalculator?.FinancialInfo?.calculatedFinance?.financeValues ? transformIntoValidRoundedValue(summaryCalculator?.FinancialInfo.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex][summaryCalculator.IncludeTaxes ? 'monthlyWithTaxes' : 'monthly']) : '';	//Finance - Monthly value
            vehicleDataJSON.apr.selected.approxBiweekly = summaryCalculator?.FinancialInfo?.calculatedFinance?.financeValues ? transformIntoValidRoundedValue(summaryCalculator?.FinancialInfo.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex][summaryCalculator.IncludeTaxes ? 'biWeeklyWithTaxes' : 'biWeekly']) : '';	//Finance - Bi-Weekly value
            vehicleDataJSON.apr.selected.approxWeekly = summaryCalculator?.FinancialInfo?.calculatedFinance?.financeValues ? transformIntoValidRoundedValue(summaryCalculator?.FinancialInfo.calculatedFinance.financeValues[summaryCalculator.FinanceTermIndex][summaryCalculator.IncludeTaxes ? 'weeklyWithTaxes' : 'weekly']) : '';	//Finance - Weekly value
            
            vehicleDataJSON.lease.selected.months = summaryCalculator?.LeaseTerm ? summaryCalculator.LeaseTerm : '';	//Lease - selected Term
            let leaseRate = summaryCalculator?.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].leaseRate;
            if(summaryCalculator.LoyaltyChecked){
              leaseRate = summaryCalculator?.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex].leaseRateDiscounted;
            }
            vehicleDataJSON.lease.selected.rate = leaseRate;	//Lease - selected Rate
            vehicleDataJSON.lease.selected.approxMonthly = summaryCalculator?.FinancialInfo?.calculatedLease?.leaseValues ? transformIntoValidRoundedValue(summaryCalculator.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex][summaryCalculator.IncludeTaxes ? 'monthlyWithTaxes' : 'monthly']) : '';	//Lease - Monthly value
            vehicleDataJSON.lease.selected.approxBiweekly = summaryCalculator?.FinancialInfo?.calculatedLease?.leaseValues ? transformIntoValidRoundedValue(summaryCalculator.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex][summaryCalculator.IncludeTaxes ? 'biWeeklyWithTaxes' : 'biWeekly']) : ''; //getLeaseBiWeeklyFromOptions(Accessory.price, financial.calculatedLease.leaseValues[leaseTermIndex].leaseRate, financial.calculatedLease.leaseValues[leaseTermIndex].term),	//Lease - Bi-Weekly value
            vehicleDataJSON.lease.selected.approxWeekly = summaryCalculator?.FinancialInfo?.calculatedLease?.leaseValues ? transformIntoValidRoundedValue(summaryCalculator.FinancialInfo.calculatedLease.leaseValues[summaryCalculator.LeaseTermIndex][summaryCalculator.IncludeTaxes ? 'weeklyWithTaxes' : 'weekly']) : ''; //Lease - Weekly value

            //console.log(JSON.stringify(vehicleDataJSON))
          return JSON.stringify(vehicleDataJSON)
        }

        if(typeof(summaryCalculator) === 'object'){
          reqData.data = createJsonOutput();
        }

        if(isModal){
          reqData.pid = pidController.getPid('contactDealer');
        }else{
          reqData.pid = pidController.getPid('getLocalPrice');
        }

        if(dealerID){
          reqData.dealerID = dealerID;
        }

        if(!reqData?.model){
          showFailureMessage();
          return;
        }

        const params = new URLSearchParams(reqData);
        const res = await axios.post(getEndpointUrl('contact-dealer'), params);
        const resData = res.data;

        if (resData && resData.Success) {
          setIsSubmitted(true);
          pushToGTMDataLayer({ formevent: 'submit'});
          data['optin'] = data.optin ? 'optin' : 'optout';
          if(typeof(summaryCalculator) === 'object'){
            data.modelYear = summaryCalculator.selectedVehicle.year;
            data.modelCarlineName = summaryCalculator.selectedVehicle.carline;
          }else if(urlparams.model){
            data.modelYear = initVehicleData.year;
            data.modelCarlineName = initVehicleData.model;
          }
          
          handleAnalyticsTrackingCodes(data, 'Form Submit', 'Send Build To Dealer Modal', 'SendBuildToDealer');
          setData(initState)
        } else {
          if (resData.Errors && resData.Errors.length > 0) {
            setFormError(resData.Errors[0])
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
  })

  const { firstname, lastname, email, postalcode, phone, preferredContact, message, optin } = data;

  function showFailureMessage(){
    // let count=0;
    // const ErrorFunc = setInterval(()=>{
    //   count++;
    //   setFormError(parse(`${languageController.getError('dataMissing1')} ${7-count} ${languageController.getError('dataMissing2')}`));
    //   if(count === 7){
    //     clearInterval(ErrorFunc);
    //     window.location = window.location.href.split("#")[0];
    //   }
    // }, 1000)
  }
  
  useEffect(() => {
    setValidations(prevValidations => {
      const newValidations = { ...prevValidations }; // Create a new object copy
      if (phoneValue.length > 9) {
        // Add 'required' rule to preferredContact
        newValidations.preferredContact = ['required'];
      } else {
        // Remove preferredContact rule
        if (newValidations.preferredContact) {
          delete newValidations.preferredContact;
        }
      }
      return newValidations;
    });
  }, [phoneValue])

  function getFormContent(){
    return(
      <FormContainer
          className="mz-send-build-to-dealer"
          isSubmitted={isSubmitted}
          heading={(
            <Fragment>
                  <h3 className="text--center">{languageController.getCopy('sendBuildToDealer', 'heading')}</h3>

              <div className="mz-send-build-to-dealer__vehicle">
                {/* Vehicle name and image will be handled by B&P. */}
                  <h4 className="mz-send-build-to-dealer__vehicle-name text--center">{initVehicleData ? language==='en' ? parse(`${initVehicleData?.year} ${initVehicleData?.title}`) : parse(`${initVehicleData?.title} ${initVehicleData?.year}`):''   }</h4>

              </div>
            </Fragment>
          )}
          confirmation={(
            <FormConfirmation
              heading={parse(languageController.getCopy('sendBuildToDealer', 'confirmationHeading'))}
              subHeading={parse(dealerID ? languageController.getCopy('sendBuildToDealer', 'confirmationSubHeadingRetailer') : dealerName ? `${languageController.getCopy('sendBuildToDealer', 'confirmationSubHeading')} ${decodeURI(dealerName)}` : languageController.getCopy('sendBuildToDealer', 'confirmationSubHeading'))}
              buttonLabel={isModal ? languageController.getCopy('sendBuildToDealer', 'confirmationSubmit'): null}
              onClick={() => {
                closeModal(modalRef.current);
                setIsSubmitted(false);
                setTimeout(() => {
                  modalRef.current.querySelector('button[type="submit"').disabled = false;
                }, 1200);
              }}
            />
          )}
        >
          <Form
            onSubmit={handleSubmit}
            isDark={false}
            noValidate={true}
            errorMessage={formError}
          >
            <FormGroup md={2}>
              <Input
                type="text"
                name="firstname"
                label={languageController.getFormCopy('label', 'firstname')}
                value={firstname}
                isRequired={true}
                errorMessage={errors.firstname}
                onChange={handleChange}
                maxLength={50}
              />
              <Input
                type="text"
                name="lastname"
                label={languageController.getFormCopy('label', 'lastname')}
                value={lastname}
                isRequired={true}
                errorMessage={errors.lastname}
                onChange={handleChange}
                maxLength={50}
              />
            </FormGroup>
            <Input
              type="email"
              name="email"
              label={languageController.getFormCopy('label', 'email')}
              value={email}
              isRequired={true}
              errorMessage={errors.email}
              onChange={handleChange}
              maxLength={320}
            />
             <FormGroup md={2}>
                <Input
                  type="text"
                  name="postalcode"
                  label={languageController.getFormCopy('label', 'postalcode')}
                  value={postalcode}
                  isRequired={true}
                  errorMessage={errors.postalcode}
                  onChange={handleChange}
                  maxLength={7}
                />
               <Input
                    type="text"
                    name="phone"
                    label={languageController.getFormCopy('label', 'phone')}
                    id="contact-phone"
                    value={phone}
                    isRequired={false}
                    errorMessage={errors.phone}
                    onChange={(e)=>{
                      handleChange(e)
                      if(phoneValue != e.target.value)setPhoneValue(e.target.value.replace(/\D/g, ''))
                    }}
                    maxLength={14}
                  />
                </FormGroup>
                {phoneValue.length > 9 &&
                  <FormGroup md={2}>
                    <Select
                      name="preferredContact"
                      label={languageController.getFormCopy('label', 'preferredContact')}
                      id="contact-preferredContact"
                      value={preferredContact}
                      isRequired={true}
                      errorMessage={errors.preferredContact}
                      onChange={handleChange}
                      placeholder={languageController.getFormCopy('placeholder', 'preferredContact')}
                      options={formLang.select.preferredContact.map(subject => ({
                        value: subject[language],
                        label: subject[language],
                      }))}
                    />
                  </FormGroup>
                }
                <Textarea
                    name="message"
                    label={languageController.getFormCopy('label', 'message')}
                    id="contact-message"
                    value={message}
                    isRequired={false}
                    errorMessage={errors.message}
                    onChange={handleChange}
                    maxLength={1999}
                    rows={5}
                  />

              <div className="mz-form-container__disclaimer label label--tight">
                    <Checkbox
                    name="optin"
                    checked={optin}
                    onChange={() => setData({ ...data, optin: !optin })}
                    label={formDisclaimer ? parse(formDisclaimer) : ''}
                  />
                </div>

            <div className="mz-container-flex">
              <Button
                type="submit"
                className="mz-btn--primary mz-btn--red"
                label={languageController.getCopy('sendBuildToDealer', 'submit')}
              />
              </div>
          </Form>
        </FormContainer>
    )
  }

  return (
    <>
      {isModal &&
        <Modal
          className="mz-modal-form mz-send-build-to-dealer-modal"
          id="mz-react-send-build-to-dealer-modal"
          onClose={() => {
            setIsSubmitted(false)
          }}
          modalRef={modalRef}
        >
          {getFormContent()}
        </Modal>
      }
      {!isModal &&
        <div className="mz-reserve-your-mazda">
           <div className="mz-container-flex">
            <div className="mz-full-width" style={{'max-width':'700px'}}>
              {getFormContent()}
             </div>
          </div>
        </div>
      }
    </> )
}

SendBuildToDealer.propTypes = {
  formExtraParams: PropTypes.object
}

export default SendBuildToDealer